export default __webpack_public_path__ + "static/media/student_club.405babab.jpg";